import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/quiz-platform/quiz-platform/src/app/family/FamilyClient.tsx");
